<template>
  <div class="box">
    <div class="bodyBox">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="账号" prop="username" label-width="60">
          <el-input v-model="ruleForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" label-width="60">
          <el-input
            v-model="ruleForm.password"
            :type="showPassword ? 'text' : 'password'"
          >
            <i slot="suffix" @click="switchPassword">
              <img
                v-if="showPassword"
                class="input_icon"
                src="@/assets/icon/true.png"
              />
              <img v-else class="input_icon" src="@/assets/icon/show.png" /> </i
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from "@/uitl/api";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      showPassword: false,
      ruleForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    switchPassword() {
      this.showPassword = !this.showPassword;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          login(this.ruleForm)
            .then((res) => {
              console.log(res.data.access_token);
              this.$message({
                message: "登录成功",
                type: "success",
              });
              localStorage.setItem("token", res.data.access_token);
              localStorage.setItem("url", "");
              this.$router.push("/home/amap");
            })
            .catch((erro) => {
              this.$message.error("账号或密码错误");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped lang="less">
.bodyBox {
  position: absolute;
  left: 50%;
  bottom: 50%;
  transform: translateX(-50%);
}
.input_icon {
  width: 28px;
  height: 28px;
  margin-top: 6px;
}
</style>
